import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { get } from '../../controllers/apiController';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [leads, setLeads] = useState([]);
    const [pipelineBreakdown, setPipelineBreakdown] = useState([]);
    const [hatirlatmalar, setHatirlatmalar] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Anasayfa | LEVELUP CRM";
        const fetchAll = async () => {
            try {
                const [formsRes, anaRes] = await Promise.all([
                    get("forms/"),
                    get("reports/analytics")
                ]);
                const allLeads = formsRes || [];
                setLeads(allLeads);
                setPipelineBreakdown(anaRes?.pipelineBreakdown || []);

                const now = new Date();
                now.setHours(0, 0, 0, 0);
                const next7 = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
                setHatirlatmalar(
                    allLeads
                        .filter(l => {
                            if (!l.Hatirlatma_Tarihi) return false;
                            const d = new Date(l.Hatirlatma_Tarihi);
                            return d >= now && d <= next7;
                        })
                        .sort((a, b) => new Date(a.Hatirlatma_Tarihi) - new Date(b.Hatirlatma_Tarihi))
                        .slice(0, 10)
                );
            } catch {
                toast.error("Veriler alınırken bir hata oluştu!");
            }
            setIsLoading(false);
        };
        fetchAll();
    }, []);

    const total = leads.length;
    const kazanildi = pipelineBreakdown.filter(s => s.Tur === 'kazanildi').reduce((acc, s) => acc + Number(s.lead_sayisi), 0);
    const kaybedildi = pipelineBreakdown.filter(s => s.Tur === 'kaybedildi').reduce((acc, s) => acc + Number(s.lead_sayisi), 0);
    const donusum = total > 0 ? ((kazanildi / total) * 100).toFixed(1) : 0;

    const now = new Date();
    const buAy = leads.filter(l => {
        const d = new Date(l.LeadInfo?.Tarih);
        return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    }).length;

    const sonLeadler = [...leads]
        .sort((a, b) => new Date(b.LeadInfo?.Tarih) - new Date(a.LeadInfo?.Tarih))
        .slice(0, 10);

    const formatDate = (d) => {
        const dt = new Date(d);
        return `${dt.getDate().toString().padStart(2, '0')}.${(dt.getMonth() + 1).toString().padStart(2, '0')}.${dt.getFullYear()}`;
    };

    const KPI_ITEMS = [
        { icon: 'users', color: '#3b82f6', value: total, label: 'Toplam Lead', sub: `Bu ay: ${buAy}` },
        { icon: 'check-circle', color: '#10b981', value: kazanildi, label: 'Kazanılan' },
        { icon: 'x-circle', color: '#ef4444', value: kaybedildi, label: 'Kaybedilen' },
        { icon: 'trending-up', color: '#6366f1', value: `%${donusum}`, label: 'Dönüşüm Oranı' },
    ];

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                            </ul>
                        </div>
                        <div className="page-header-right ms-auto">
                            <div className="page-header-right-items">
                                <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                                    <a href="/reports" className="btn btn-sm btn-primary">
                                        <i className="feather-bar-chart-2 me-1"></i>Detaylı Rapor
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="main-content">
                        {isLoading ? (
                            <div className="w-100 d-flex align-items-center justify-content-center" style={{ height: '70svh' }}>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Yükleniyor...</span>
                                </div>
                            </div>
                        ) : (
                            <>
                                {/* KPI Kartları */}
                                <div className="row g-3 mb-4">
                                    {KPI_ITEMS.map((k, i) => (
                                        <div key={i} className="col-6 col-md-3">
                                            <div className="card border-0 shadow-sm">
                                                <div className="card-body d-flex align-items-center gap-3 py-4">
                                                    <div className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                                                        style={{ width: 52, height: 52, background: k.color + '18', color: k.color }}>
                                                        <i className={`feather-${k.icon} fs-4`}></i>
                                                    </div>
                                                    <div>
                                                        <h3 className="fw-bold mb-0" style={{ color: k.color }}>{k.value}</h3>
                                                        <p className="text-muted mb-0 small">{k.label}</p>
                                                        {k.sub && <span className="text-muted" style={{ fontSize: 11 }}>{k.sub}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Pipeline Aşama Özeti */}
                                {pipelineBreakdown.length > 0 && (
                                    <div className="card border-0 shadow-sm mb-4">
                                        <div className="card-header bg-white border-bottom py-3 d-flex align-items-center justify-content-between">
                                            <h6 className="mb-0 fw-semibold">
                                                <i className="feather-git-branch me-2 text-primary"></i>Pipeline Durumu
                                            </h6>
                                            <a href="/forms" className="btn btn-sm btn-outline-primary">Tüm Leadler</a>
                                        </div>
                                        <div className="card-body">
                                            <div className="d-flex flex-wrap gap-2">
                                                {pipelineBreakdown.map(stage => (
                                                    <div key={stage.Asama_ID}
                                                        className="d-flex align-items-center gap-2 px-3 py-2 rounded-3"
                                                        style={{
                                                            background: (stage.Renk || '#6366f1') + '15',
                                                            border: `1px solid ${(stage.Renk || '#6366f1')}35`,
                                                            cursor: 'default'
                                                        }}>
                                                        <span className="fw-bold fs-5" style={{ color: stage.Renk || '#6366f1' }}>
                                                            {Number(stage.lead_sayisi)}
                                                        </span>
                                                        <span className="small text-muted">{stage.Ad}</span>
                                                        {stage.Tur === 'kazanildi' && <i className="feather-check-circle small text-success"></i>}
                                                        {stage.Tur === 'kaybedildi' && <i className="feather-x-circle small text-danger"></i>}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Alt Grid: Hatırlatmalar + Son Leadler */}
                                <div className="row g-4">
                                    {/* Yaklaşan Hatırlatmalar */}
                                    <div className="col-xl-5">
                                        <div className="card border-0 shadow-sm h-100">
                                            <div className="card-header bg-white border-bottom py-3 d-flex align-items-center justify-content-between">
                                                <h6 className="mb-0 fw-semibold">
                                                    <i className="feather-bell me-2 text-warning"></i>
                                                    Yaklaşan Hatırlatmalar
                                                    <span className="text-muted fw-normal ms-1" style={{ fontSize: 12 }}>(7 Gün)</span>
                                                </h6>
                                                {hatirlatmalar.length > 0 && (
                                                    <span className="badge bg-warning text-dark">{hatirlatmalar.length}</span>
                                                )}
                                            </div>
                                            <div className="card-body p-0">
                                                {hatirlatmalar.length === 0 ? (
                                                    <div className="text-center py-5 text-muted">
                                                        <i className="feather-check-circle fs-1 d-block mb-2 text-success"></i>
                                                        <p className="small mb-0">Önümüzdeki 7 günde hatırlatma yok</p>
                                                    </div>
                                                ) : (
                                                    <ul className="list-group list-group-flush">
                                                        {hatirlatmalar.map((lead, i) => {
                                                            const d = new Date(lead.Hatirlatma_Tarihi);
                                                            const stage = pipelineBreakdown.find(s => Number(s.Asama_ID) === Number(lead.LeadInfo?.Pipeline_Asama_ID));
                                                            const isToday = d.toDateString() === new Date().toDateString();
                                                            return (
                                                                <li key={i}
                                                                    className="list-group-item border-0 px-4 py-3"
                                                                    onClick={() => navigate(`/lead-detail?id=${lead.Form_ID}`)}
                                                                    style={{ cursor: 'pointer', background: isToday ? '#fffbeb' : 'transparent' }}>
                                                                    <div className="d-flex align-items-center justify-content-between gap-2">
                                                                        <div className="d-flex align-items-center gap-2 flex-grow-1 overflow-hidden">
                                                                            <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                                                                                style={{ width: 32, height: 32, background: isToday ? '#fef3c7' : '#f1f5f9' }}>
                                                                                <i className={`feather-bell small ${isToday ? 'text-warning' : 'text-muted'}`}></i>
                                                                            </div>
                                                                            <div className="overflow-hidden">
                                                                                <div className="fw-semibold small text-truncate">{lead.LeadInfo?.Adi_Soyadi}</div>
                                                                                <div className="text-muted" style={{ fontSize: 11 }}>
                                                                                    {d.toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', '')}
                                                                                    {isToday && <span className="ms-1 badge bg-warning text-dark" style={{ fontSize: 9 }}>BUGÜN</span>}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {stage && (
                                                                            <span className="badge flex-shrink-0" style={{ background: (stage.Renk || '#6366f1') + '20', color: stage.Renk || '#6366f1', fontSize: 10 }}>
                                                                                {stage.Ad}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Son Eklenen Leadler */}
                                    <div className="col-xl-7">
                                        <div className="card border-0 shadow-sm h-100">
                                            <div className="card-header bg-white border-bottom py-3 d-flex align-items-center justify-content-between">
                                                <h6 className="mb-0 fw-semibold">
                                                    <i className="feather-clock me-2 text-primary"></i>
                                                    Son Eklenen Leadler
                                                </h6>
                                                <a href="/forms" className="btn btn-sm btn-outline-primary">Tümünü Gör</a>
                                            </div>
                                            <div className="card-body p-0">
                                                {sonLeadler.length === 0 ? (
                                                    <div className="text-center py-5 text-muted">
                                                        <i className="feather-inbox fs-1 d-block mb-2"></i>
                                                        <p className="small mb-0">Henüz lead yok</p>
                                                    </div>
                                                ) : (
                                                    <ul className="list-group list-group-flush">
                                                        {sonLeadler.map((lead, i) => {
                                                            const stage = pipelineBreakdown.find(s => Number(s.Asama_ID) === Number(lead.LeadInfo?.Pipeline_Asama_ID));
                                                            const kaynak = lead.LeadInfo?.Kaynak || 'Manuel';
                                                            const kaynakColor = kaynak === 'Meta' ? '#1877f2' : kaynak === 'Ads' ? '#ea4335' : '#6b7280';
                                                            return (
                                                                <li key={i}
                                                                    className="list-group-item border-0 px-4 py-3"
                                                                    onClick={() => navigate(`/lead-detail?id=${lead.Form_ID}`)}
                                                                    style={{ cursor: 'pointer' }}>
                                                                    <div className="d-flex align-items-center justify-content-between gap-3">
                                                                        <div className="d-flex align-items-center gap-2 flex-grow-1 overflow-hidden">
                                                                            <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                                                                                style={{ width: 36, height: 36, background: '#f1f5f9' }}>
                                                                                <i className="feather-user small text-muted"></i>
                                                                            </div>
                                                                            <div className="overflow-hidden">
                                                                                <div className="fw-semibold small text-truncate">{lead.LeadInfo?.Adi_Soyadi}</div>
                                                                                <div className="d-flex align-items-center gap-2" style={{ fontSize: 11 }}>
                                                                                    <span style={{ color: kaynakColor }}>{kaynak}</span>
                                                                                    <span className="text-muted">·</span>
                                                                                    <span className="text-muted">{formatDate(lead.LeadInfo?.Tarih)}</span>
                                                                                    {lead.LeadInfo?.Telefon && lead.LeadInfo.Telefon !== 'Bilinmiyor' && (
                                                                                        <>
                                                                                            <span className="text-muted">·</span>
                                                                                            <span className="text-muted">{lead.LeadInfo.Telefon}</span>
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex-shrink-0">
                                                                            {stage ? (
                                                                                <span className="badge" style={{
                                                                                    background: (stage.Renk || '#6366f1') + '20',
                                                                                    color: stage.Renk || '#6366f1',
                                                                                    fontSize: 10,
                                                                                    border: `1px solid ${(stage.Renk || '#6366f1')}30`
                                                                                }}>
                                                                                    {stage.Ad}
                                                                                </span>
                                                                            ) : (
                                                                                <span className="badge bg-light text-muted" style={{ fontSize: 10 }}>Atanmamış</span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </main>
        </Layout>
    );
};

export default Dashboard;
